module.exports = __webpack_public_path__ + "img/dashboard-main-mobile-fr.e4da203b.jpg";